import React, { useEffect } from 'react'
import { TextFieldSeeker } from "@ui-seeker/core"


export default function ModalOfficesSelector({ applyFilters, filteredOffices, onChangeOffice }) {

	useEffect(() => {
		applyFilters()
	}, [filteredOffices])

	return <TextFieldSeeker
		startIcon="city"
		label="Filter offices"
		placeholder="All offices"
		value={filteredOffices}
		onChange={onChangeOffice}
	/>
}